import { FormType } from '@lx/quote-tool/shared/types';

export function tellUsAboutYouSectionIndex(formType: FormType, hasSupplementsAvailable: boolean): number {
  if (formType === FormType.FREE_QUOTE || formType === FormType.ENROLLMENT) {
    return hasSupplementsAvailable ? 5 : 4;
  } else {
    return 3;
  }
}
